export const MASK = { N: 1, E: 2, S: 4, W: 8, NE: 16, SE: 32, SW: 64, NW: 128 };

export function normalizeBlobMask(mask) {
  let normalized = mask & 15;
  if ((mask & MASK.NE) && (mask & MASK.N) && (mask & MASK.E)) normalized |= MASK.NE;
  if ((mask & MASK.SE) && (mask & MASK.S) && (mask & MASK.E)) normalized |= MASK.SE;
  if ((mask & MASK.SW) && (mask & MASK.S) && (mask & MASK.W)) normalized |= MASK.SW;
  if ((mask & MASK.NW) && (mask & MASK.N) && (mask & MASK.W)) normalized |= MASK.NW;
  return normalized;
}

export const PIPE_MASKS = Array.from({ length: 16 }, (_, mask) => mask);
export const BLOB_MASKS = [...new Set(Array.from({ length: 256 }, (_, mask) => normalizeBlobMask(mask)))].sort((a, b) => a - b);
